import { createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "relative bg-gray-200 flex flex-col min-h-0"
};
const _hoisted_2 = {
  class: "absolute -left-8 top-1/2 -translate-y-1/2 z-20"
};
const _hoisted_3 = {
  class: "absolute -right-8 top-1/2 -translate-y-1/2 z-20"
};
const _hoisted_4 = {
  class: "absolute -bottom-10 left-1/2 transform -translate-x-1/2 flex space-x-2 p-4"
};
import { computed, onUnmounted, ref, watch } from "vue";
import LlSecondaryButton from "@/components/LlSecondaryButton.vue";
import AttachmentPreview from "./AttachmentPreview.vue"; // Adjust the import path as needed
import { useAttachmentsStore } from "@/services/useAttachmentsStore";
export default {
  __name: 'MultipleAttachmentPreview',
  props: {
    previewSource: {
      type: Array,
      required: true
    },
    selectedFileIndex: {
      type: Number,
      required: false,
      default: 0
    }
  },
  emits: ["exitPreview", "addAttachment", "cancel"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const attachmentsStore = useAttachmentsStore();
    const images = computed(() => props.previewSource ?? []);
    const currentIndex = ref(props.selectedFileIndex ?? 0);
    watch(() => props.selectedFileIndex, index => {
      currentIndex.value = index ?? 0;
    });
    const showAttachmentPreview = ref(true);
    const previewExistingMode = ref(false); // Adjust this based on your requirements

    const currentImage = computed(() => images.value[currentIndex.value] ?? null);
    const objectUrls = ref(new Map());
    const resolving = ref(false);
    const resolveError = ref("");
    let resolveToken = 0;
    const resolvedSource = computed(() => {
      const image = currentImage.value;
      if (!image) return "";
      if (!image.expenseAttachmentId) return image.src ?? "";
      return objectUrls.value.get(image.expenseAttachmentId) ?? "";
    });
    const resolveCurrentImage = async () => {
      const image = currentImage.value;
      const token = resolveToken += 1;
      resolveError.value = "";
      const id = image?.expenseAttachmentId;
      if (!id || objectUrls.value.has(id)) {
        resolving.value = false;
        return;
      }
      resolving.value = true;
      try {
        const blob = await attachmentsStore.downloadAttachmentBlob(id);
        objectUrls.value.set(id, URL.createObjectURL(blob));
      } catch {
        if (token === resolveToken) resolveError.value = "Unable to load this attachment.";
      } finally {
        if (token === resolveToken) resolving.value = false;
      }
    };
    watch(currentImage, resolveCurrentImage, {
      immediate: true
    });
    onUnmounted(() => {
      objectUrls.value.forEach(url => URL.revokeObjectURL(url));
      objectUrls.value.clear();
    });
    const showNextImage = () => {
      if (currentIndex.value < images.value.length - 1) {
        currentIndex.value++;
      }
    };
    const showPreviousImage = () => {
      if (currentIndex.value > 0) {
        currentIndex.value--;
      }
    };
    const emits = __emit;
    return (_ctx, _cache) => {
      const _component_v_card_text = _resolveComponent("v-card-text");
      return _openBlock(), _createBlock(_component_v_card_text, {
        class: "flex flex-col min-h-0"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_withDirectives(_createElementVNode("div", _hoisted_2, [_createVNode(LlSecondaryButton, {
          icon: "mdi-arrow-left",
          "aria-label": "Previous attachment",
          onClick: showPreviousImage
        })], 512), [[_vShow, currentIndex.value !== 0]]), currentImage.value ? (_openBlock(), _createBlock(AttachmentPreview, {
          key: 0,
          fileType: currentImage.value.fileType,
          previewSource: resolvedSource.value,
          previewExistingMode: previewExistingMode.value,
          showAttachmentPreview: showAttachmentPreview.value,
          hideActionButtons: true,
          fileName: currentImage.value.name,
          loading: resolving.value,
          errorMessage: resolveError.value,
          onCancel: _cache[0] || (_cache[0] = $event => _ctx.$emit('cancel'))
        }, null, 8, ["fileType", "previewSource", "previewExistingMode", "showAttachmentPreview", "fileName", "loading", "errorMessage"])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_3, [_createVNode(LlSecondaryButton, {
          icon: "mdi-arrow-right",
          "aria-label": "Next attachment",
          onClick: showNextImage
        })], 512), [[_vShow, currentIndex.value !== images.value.length - 1]]), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images.value, (image, index) => {
          return _openBlock(), _createElementBlock("span", {
            key: index,
            class: _normalizeClass(["h-4 w-4 rounded-full", currentIndex.value === index ? 'bg-black' : 'bg-gray-300'])
          }, null, 2);
        }), 128))])])]),
        _: 1
      });
    };
  }
};